module.exports = __webpack_public_path__ + "static/media/Formato_Carga_Proveeduría_Alterna_(FPA).ac568f99.xlsx";